var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopBgShadow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 873,
    height: 745,
    viewBox: "0 0 873 745",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M840.825 0C861.599 30.558 873 63.8071 873 98.584C873 248.466 661.238 369.969 400.015 369.969C231.64 369.969 83.8134 319.488 2.12844e-05 243.465L0 7.35073e-05L840.825 0Z",
    fill: "#0008C3",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.563 0.000976562C415.751 74.9992 491.816 195.914 491.816 332.307C491.816 559.882 280.053 744.369 18.8309 744.369C12.5244 744.369 6.24667 744.261 6.50467e-05 744.048L0 0.00100266L298.563 0.000976562Z",
    fill: "#0008C3",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopBgShadow);
export default __webpack_public_path__ + "static/media/desktop-bg-shadow.df91568a732d62272cc0f0e422cfd287.svg";
export { ForwardRef as ReactComponent };